function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M15.392 22.306l.937-.936a.57.57 0 000-.803L7.782 12l8.547-8.567a.57.57 0 000-.803l-.937-.936a.566.566 0 00-.802 0l-9.905 9.905a.566.566 0 000 .802l9.905 9.905c.221.222.58.222.802 0z"
});

function SvgBackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgBackinline;